import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { PublicLayout } from "@/components/PublicLayout";
import { Markdown } from "@/components/Markdown";
import api from "@/lib/api";

export default function ConseilPost() {
  const { slug } = useParams();
  const { data: article, isLoading, isError } = useQuery({
    queryKey: ["kb", slug],
    queryFn: async () => (await api.get(`/kb/${slug}`)).data,
  });
  return (
    <PublicLayout>
      <article className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <Link to="/conseils" className="inline-flex items-center gap-1 text-sm font-medium text-slate-500 hover:text-[#263871]"><ArrowLeft className="h-4 w-4" />Tous les conseils</Link>
        {isLoading ? (
          <p className="mt-8 text-slate-500">Chargement…</p>
        ) : isError || !article ? (
          <p className="mt-8 text-slate-500">Article introuvable.</p>
        ) : (
          <>
            <span className="mt-6 block text-xs font-semibold uppercase tracking-wide text-[#1D9BF0]">{article.category}</span>
            <h1 className="mt-2 text-3xl font-extrabold text-[#263871] sm:text-4xl">{article.title}</h1>
            <div className="mt-8"><Markdown text={article.body_md} /></div>
          </>
        )}
      </article>
    </PublicLayout>
  );
}
